import React from "react";

const Title = () => {
  return <>Products</>;
};

export default Title;
